export default "__VITE_ASSET__747eddc2__"